// extracted by mini-css-extract-plugin
export default {"shortcut-overview-panel":"cD7X","shortcutOverviewPanel":"cD7X"};